import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Import Tailwind CSS first
import './assets/css/index.css'

// Import legacy styles DECOUPLED - moved to route level components to reduce unused size
// import './assets/css/styles.css'
// import './assets/css/landing.css'

import App from './App.vue'
import router from './router'



// Global handler for stale chunk loading errors & benign browser extension noise suppression
window.addEventListener('error', (event) => {
  const msg = String(event?.message || event?.error?.message || event?.error || '');
  // Suppress benign browser extension disconnects & permissions policy noise
  if (
    msg.includes('Could not establish connection') ||
    msg.includes('Receiving end does not exist') ||
    msg.includes('message channel closed') ||
    msg.includes('Permissions policy violation') ||
    msg.includes('unload is not allowed')
  ) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed')
  ) {
    const reloadKey = 'chunk_reload_retry_' + (event.filename || 'unknown');
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, 'true');
      console.warn('New deployment detected / stale asset chunk. Auto-reloading page...');
      window.location.reload();
    }
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reasonMsg = String(event?.reason?.message || event?.reason?.stack || event?.reason || '');
  // Suppress benign browser extension disconnects & permissions policy noise
  if (
    reasonMsg.includes('Could not establish connection') ||
    reasonMsg.includes('Receiving end does not exist') ||
    reasonMsg.includes('message channel closed') ||
    reasonMsg.includes('Permissions policy violation') ||
    reasonMsg.includes('unload is not allowed')
  ) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  if (
    reasonMsg.includes('Failed to fetch dynamically imported module') ||
    (event?.reason?.name === 'TypeError' && (reasonMsg.includes('fetch') || reasonMsg.includes('Import')))
  ) {
    const reloadKey = 'chunk_reload_retry_unhandled';
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, 'true');
      console.warn('Unhandled dynamic import error detected. Auto-reloading page...');
      window.location.reload();
    }
  }
});

import { vReveal } from './directives/vReveal'
import { vStagger } from './directives/vStagger'

// 2. Initialize Vue App
const app = createApp(App)

app.directive('reveal', vReveal)
app.directive('stagger', vStagger)

app.use(createPinia())
app.use(router)

if (typeof window !== 'undefined') {
  window.vueRouter = router
}

app.mount('#app')

// 3. Initialize Version Broadcast & Remote Auto-Reload Service
import { initVersionBroadcastListener, initPeriodicVersionCheck } from './services/versionBroadcastService.js'
try {
  initVersionBroadcastListener()
  initPeriodicVersionCheck(2.5 * 60 * 1000) // check build artifact every 2.5 minutes
} catch (err) {
  console.warn('[VersionBroadcast] Init warning:', err)
}

// 4. Hook modern Vue store to legacy window.Utils helpers if they are defined by legacy apps
import { useLoadingStore } from './stores/loading.js'
import { initGlobalButtonLoading } from './services/buttonLoadingService.js'

// Initialize Universal Button Loading & Async Interceptor
try {
  initGlobalButtonLoading()
} catch (err) {
  console.warn('[ButtonLoading] Init warning:', err)
}

try {
  const loadingStore = useLoadingStore()
  window.__isGlobalProcessRunning = () => loadingStore.isLoading
  window.__triggerVueLoader = (show, message = 'Memproses...', force = false) => {
    if (show) {
      loadingStore.startLoading(message)
    } else {
      if (force) {
        loadingStore.forceStopLoading()
      } else {
        loadingStore.stopLoading()
      }
    }
  }
} catch (e) {
  console.warn('Failed to bind __triggerVueLoader immediately:', e)
}


// 5. Import legacy app.js DECOUPLED - dynamically streamed in relevant dashboard pages only
// import './legacy/app.js'
